import React, { useContext } from 'react';
import {
  Text,
  Badge,
  Button,
  Box,
  useClipboard,
  Icon,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  useColorMode,
} from '@chakra-ui/react';
import { PencilSimple, Trash } from '@phosphor-icons/react';
import { useMutation } from '@apollo/client';
import { useDisclosure } from '@chakra-ui/react';
import moment from 'moment';

import SpinnerContext from '../../contexts/SpinnerContext';
import { useCustomToast } from '../../hooks/useCustomToast';
import { DELETE_COUPON } from './query';

export const CouponCard = ({ id, code, type, amount, uses, companies, refetch, openModal }) => {
  const { onCopy, hasCopied } = useClipboard(code);
  const cancelRef = React.useRef();
  const { toggleSpinner } = useContext(SpinnerContext);
  const [deleteCoupon] = useMutation(DELETE_COUPON);
  const toast = useCustomToast();
  const { colorMode } = useColorMode();
  const { isOpen: isOpenDeleteModal, onOpen: onOpenDeleteModal, onClose: onCloseDeleteModal } = useDisclosure();

  const handleDelete = async () => {
    try {
      toggleSpinner(true);
      await deleteCoupon({
        variables: {
          where: { id },
        },
      });
      await refetch();
      toast({
        title: 'Erfolg!',
        description: 'Der Coupon wurde gelöscht.',
        status: 'success',
      });
    } catch (error) {
      console.log(error);
      toast({
        description: 'Ein Fehler ist aufgetreten!',
        status: 'error',
      });
    }
    toggleSpinner(false);
  };

  return (
    <Box width="100%" rounded="md" borderWidth="1px" py="4" px="6" _hover={{ boxShadow: 'md' }} position="relative">
      <Badge>{type}</Badge>

      {/* <Icon as={HiPencilAlt} position="absolute" right="37px" top="15px" cursor="pointer" onClick={openModal} /> */}

      {/* <Icon as={HiTrash} position="absolute" right="15px" top="15px" cursor="pointer" color="red.500" onClick={onOpenDeleteModal} /> */}

      <AlertDialog isOpen={isOpenDeleteModal} leastDestructiveRef={cancelRef} onClose={onCloseDeleteModal}>
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Coupon Löschen
          </AlertDialogHeader>

          <AlertDialogBody>Bist du sicher? Diese Aktion kann nicht rückgängig gemacht werden.</AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onCloseDeleteModal}>
              Abbrechen
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3}>
              Löschen
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <Text fontFamily="heading" fontSize="lg" fontWeight="bold" display="flex" alignItems="center" mb="2">
        {code}
        <Button ml="4" variant="link" size="xs" onClick={onCopy} colorScheme="brand" fontWeight="normal" letterSpacing="0.5px">
          {hasCopied ? 'Kopiert' : 'Kopieren'}
        </Button>
      </Text>
      {type === 'PERCENT' ? (
        <Text fontSize="md" mb="2">
          {amount} % Rabatt auf den Gesamtpreis
        </Text>
      ) : null}
      {type === 'AMOUNT' ? (
        <Text fontSize="md" mb="2">
          {new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount / 100)} Rabatt auf den Gesamtpreis
        </Text>
      ) : null}
      <Text fontSize="xs" color={colorMode === 'light' ? 'gray.700' : 'gray.300'}>
        {uses - companies.length} gültige Anwendungen übrig
      </Text>
    </Box>
  );
};
